import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import paths from "../Router/paths";
import organizationSeo from "../../Views/OrganizationUI/seoOverrides";

function getSeoConfig(path) {
  switch (path) {
      case paths.home.path:
        return paths.home
      case paths.ourMission.path:
        return paths.ourMission
      case paths.coursesPage.path:
        return paths.coursesPage
      case paths.courseListingPage.path:
        return paths.courseListingPage
      case paths.howItWorks.path:
        return paths.howItWorks
      case paths.careersPage.path:
        return paths.careersPage
      case paths.jobListingPage.path:
        return paths.jobListingPage
      case paths.becomeEducator.path:
        return paths.becomeEducator
      case paths.educatorFaq.path:
        return paths.educatorFaq
      case paths.learnerFaq.path:
        return paths.learnerFaq
      case paths.privacyPage.path:
        return paths.privacyPage
      case paths.policiesPage.path:
        return paths.policiesPage
      case paths.cancellationPage.path:
        return paths.cancellationPage
      case paths.contactPage.path:
        return paths.contactPage
      case paths.educatorProfilePage.path:
        return paths.educatorProfilePage
      case paths.accountPage.path:
        return paths.accountPage
      case paths.checkoutPage.path:
        return paths.checkoutPage
      case paths.dashboardPage.path:
        return paths.dashboardPage
      case paths.conferenceRoomPage.path:
        return paths.conferenceRoomPage
      case paths.createCoursePage.path:
        return paths.createCoursePage
      case paths.enrollmentCompletePage.path:
        return paths.enrollmentCompletePage
      case paths.onboardingPage.path:
        return paths.onboardingPage
      case paths.error404.path:
        return paths.error404
      default:
        return paths.home
    }
}

const SEO = ({ path }) => {
  const flags = useSelector((state) => state.flags.flags)
  const seoConfig =
    flags?.organizations && organizationSeo[path] ? organizationSeo[path] : getSeoConfig(path)
  const title = seoConfig.title
  const description = seoConfig.description
  const defaultImage = `${window.location.origin}/favicon.svg`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph for social media */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ defaultImage } />
      <meta property="og:type" content="website" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ defaultImage } />

      {/* Favicon */}
      <link rel="icon" href={ defaultImage } />
    </Helmet>
  );
};

export default SEO;